export default __webpack_public_path__ + "static/media/mark-read.a8acd90f.svg";